import { Grid } from '@material-ui/core';
import { PictureAsPdf } from '@material-ui/icons';
import { postAffilationFiles } from '@webapps/business';
import {
  Button,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const TransfertDocument = ({ close, data }) => {
  const {
    css,
    theme: { spacing },
  } = useStyles();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [files, setFiles] = useState([]);

  const {
    isLoading: isLoadingAffiliationFile,
    isSuccess,
    mutateAsync: mutateAffiliationFiles,
  } = useMutation(postAffilationFiles);

  const addFiles = async () => {
    await mutateAffiliationFiles({
      data: {
        params: data?.map(({ id }) => id),
        files,
      },
    });
  };

  const handleAddFiles = (file, index) => {
    files[index] = file;
  };

  const { addToast } = useToast();

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Fichier(s) envoyé(s) avec succès',
      });
      close();
    }
  }, [isSuccess]);

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: spacing(3),
        '@media (max-width:768px)': { margin: spacing(1) }
      })}
    >
      <Grid container xs={10}>
        <Grid
          className={css({
            display: 'flex',
            alignItems: 'center',
            marginTop: spacing(0),
          })}
          item
          xs={12}
        >
          <PictureAsPdf color="primary" />
          <div className={css({ marginLeft: spacing(1), color: 'black' })}>
            Envoyer des documents (PDF uniquement)
          </div>
        </Grid>
        <Grid
          className={css({ display: 'flex', marginTop: spacing(1) })}
          item
          xs={12}
        >
          {data?.length <= 0 && <div>Aucun fichier demandé</div>}
        </Grid>
        {data?.length > 0 &&
          data?.map(({ label }, index) => (
            <Grid
              key={index}
              className={css({
                display: 'flex',
                marginTop: spacing(1),
                flexDirection: 'column',
              })}
              item
              xs={12}
            >
              <div className={css({ color: 'black' })}>{label}</div>
              <div
                className={css({
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                })}
              >
                <div>
                  {files[index]
                    ? files[index]?.name
                    : 'Sélectionnez le fichier'}
                </div>
                <Button
                  component="label"
                  disableElevation
                  size="small"
                  variant="contained"
                >
                  Importer
                  <input
                    accept="application/pdf"
                    hidden
                    onChange={(event) => {
                      handleAddFiles(event.target.files[0], index);
                    }}
                    type="file"
                  />
                </Button>
              </div>
            </Grid>
          ))}
      </Grid>
      <Grid container spacing={2}>
        <Grid
          className={css({
            textAlign: 'center',
            marginTop: spacing(4),
          })}
          item
          xs
        >
          <Button
            className={css({ borderRadius: 20 })}
            color="primary"
            fullWidth
            onClick={close}
            variant="outlined"
          >
            Plus tard
          </Button>
        </Grid>
        <Grid
          className={css({
            textAlign: 'center',
            marginTop: spacing(4),
          })}
          item
          xs
        >
          <Button
            className={css({ borderRadius: 20 })}
            color="primary"
            disabled={isLoadingAffiliationFile}
            fullWidth
            onClick={addFiles}
            type="submit"
            variant="contained"
          >
            Envoyer
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

TransfertDocument.propTypes = {
  data: PropTypes.object,
  close: PropTypes.func,
};

export default TransfertDocument;
